module.exports = __webpack_public_path__ + "img/sta.85b2a0f6.png";